import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';
import { getCurrentTimeStamp } from '../api/dateFormat';

export function onBatchClassResponse(response) {
  return {
    type: types.BATCH_CLASS_RESPONSE,
    response
  };
}

export const batchClassSchedule = async (jwtToken, dispatch) => {
  const url = 'api/studenttimetable';
  return await fetchPost(url, {}, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
        return 'Error';
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        dispatch(logOut());
        return 'Logged Out';
      }
      data['timestamp'] = getCurrentTimeStamp();
      dispatch(onBatchClassResponse(data));
      return onBatchClassResponse(data);
    })
    .catch(() => {
      dispatch(
        openSnackBar({ message: 'Some error occurred', severity: 'error' })
      );
      return 'Error';
    });
};
